"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M10.0399 3.0583C10.2485 1.8883 11.271 1 12.501 1c1.2299 0 2.2525.8882 2.4611 2.0582A2.509 2.509 0 0 1 15.501 3c1.3807 0 2.5 1.1193 2.5 2.5v.55c.1615-.0328.3287-.05.5-.05 1.3798 0 2.5 1.1174 2.5 2.499v6.126c0 1.8554-.5612 3.4459-1.0737 4.7063-.2689.6614-.4945 1.1629-.6758 1.6537-.1791.4849-.2505.8004-.2505 1.015h-2c0-.5854.1785-1.1777.3744-1.708.1937-.5245.4681-1.1456.6992-1.714.4875-1.1989.9264-2.4959.9264-3.953V8.499a.4992.4992 0 0 0-.5-.499.5.5 0 0 0-.5.5v3h-2v-6a.5.5 0 0 0-1 0v6h-2v-8a.5.5 0 0 0-1 0l-.0002 8h-2v-6a.5.5 0 0 0-1 0v7.255l-1.9023.6996-1.8125-2.5925c-.1497-.2378-.4558-.3325-.7024-.1773a.5.5 0 0 0-.161.6829c1.0728 1.7505 2.0805 3.5397 3.0774 5.3342 1.0673 1.9212 1.554 3.0624 2.0147 5.2975h-2.045c-.3874-1.744-.8068-2.6861-1.718-4.3263-.9832-1.7697-1.9822-3.5368-3.0372-5.2651-.7094-1.1648-.3543-2.687.8037-3.4158 1.1609-.7307 2.6918-.389 3.4329.7611L7.0008 5.5c0-1.3807 1.1193-2.5 2.5-2.5.185 0 .3655.0201.5391.0583z"
  })];
};

exports.default = _default;